import _ from 'lodash';
import LZString from 'lz-string';

const DocumentItem = () =>
    import(/* webpackChunkName: 'DocumentItem' */ '@/components/DocumentItem');

export default {
    name: 'DocumentsGroup',

    //mixins: [Dispatchers],

    components: { DocumentItem },

    /**
     * @override
     */
    data() {
        return {
            opened: false,
            documentListArray: { name: '', items: [] },
            filteredData: { name: '', items: [] },
            docsPending: 0,
            loading: false,
            styleKey: 0,
            addOtherDocument: false
        };
    },
    props: {
        type: {
            type: String,
            required: true
        },
        uuid: {
            type: String,
            required: false
        },
        intervener: {
            type: Object,
            required: true
        },
        account: {
            type: Object,
            required: false
        },
        operation: {
            type: Object,
            required: false
        },
        itemActive: {
            type: Object,
            required: false
        },
        bankAccountsDocs: {
            type: Array,
            required: false
        },
        iiff: {
            type: Boolean,
            required: false
        }
    },

    /**
     * @override
     */
    created() {
        this.fetchData();
    },
    mounted() {
        this.$root.$on('refresh_account', this.fetchData);
        this.$root.$on('refresh_intervener', this.fetchData);
        this.$root.$on('filter_document_search_by', this.fetchData);
        this.$root.$on('uploadOk', this.fetchData);
    },
    beforeUnmount() {
        this.$root.$off('refresh_account');
        this.$root.$off('refresh_intervener');
        this.$root.$off('filter_document_search_by');
        this.$root.$off('uploadOk');
    },
    computed: {
        entity() {
            let entity;
            switch (this.type) {
                case 'account':
                    entity = this.account;
                    break;
                case 'interveners':
                    entity = this.intervener;
                    break;
                case 'bank_accounts':
                    entity = {};
                    break;
                case 'operation':
                    entity = this.operation;
                    break;
                default:
                    entity = {};
                    break;
            }
            return entity;
        },
        documents() {
            try {
                return this.documentListArray.items;
            } catch (err) {
                console.warn(err);
                return [];
            }
        }
    },
    methods: {
        /**
         * Carga la información del interviniente almacenada en localStorage
         */
        loadIntervener() {
            const raw = localStorage.getItem('PACOUS');
            let intervener;

            try {
                const decompressed = LZString.decompressFromUTF16(raw);
                if (decompressed) {
                    intervener = JSON.parse(decompressed).private_area.intervener;
                } else {
                    // Fallback al formato base64 antiguo
                    intervener = JSON.parse(decodeURIComponent(escape(window.atob(raw))))
                        .private_area.intervener;
                }
            } catch (e) {
                console.error('❌ Error al descomprimir PACOUS:', e);
                intervener = {}; // Fallback en caso de error
            }

            return intervener;
        },

        /**
         * Carga la información de las cuentas del interviniente almacenadas en localStorage
         */
        loadAccounts() {
            const raw = localStorage.getItem('PACOUS');
            let accounts;

            try {
                const decompressed = LZString.decompressFromUTF16(raw);
                if (decompressed) {
                    accounts = JSON.parse(decompressed).private_area.accounts;
                } else {
                    // Fallback al formato base64 antiguo
                    accounts = JSON.parse(decodeURIComponent(escape(window.atob(raw)))).private_area
                        .accounts;
                }
            } catch (e) {
                console.error('❌ Error al descomprimir PACOUS:', e);
                accounts = {}; // Fallback en caso de error
            }

            return accounts;
        },

        /**
         * Carga los datos (lista de documentos)
         */
        async fetchData(filterData) {
            try {
                this.loading = true;
                switch (this.type) {
                    case 'account': {
                        // Init fix/YURI-2688
                        let accounts = this.loadAccounts();
                        let uuidAccountExists = false;

                        for (let loadedAccountIndex in accounts) {
                            if (this.account.uuid == accounts[loadedAccountIndex].uuid) {
                                uuidAccountExists = true;
                                break;
                            }
                        }

                        if (uuidAccountExists) {
                            // End fix/YURI-2688
                            // En lugar de ejecutar la siguiente línea directamente, se comprueba que la cuenta que tiene este componente exista.
                            // Esto debe mejorarse y comprobar por qué al hacer login con otra cuenta distinta este componente parece instanciarse dos veces (con los uuids de la cuenta presente y la anterior)
                            this.documentListArray = this.fetchDocumentsData(this.uuid);
                        }
                        break;
                    }
                    case 'interveners': {
                        // Init fix/YURI-2688
                        let loadedIntervener = this.loadIntervener();
                        if (
                            this.intervener.uuid == loadedIntervener.uuid ||
                            (this.intervener.personal_data &&
                                this.intervener.personal_data.intervener_type === 'J')
                        ) {
                            // End fix/YURI-2688
                            // En lugar de ejecutar la siguiente línea directamente, se comprueba que la cuenta que tiene este componente exista.
                            // Esto debe mejorarse y comprobar por qué al hacer login con otra cuenta distinta este componente parece instanciarse dos veces (con los uuids de la cuenta presente y la anterior)
                            this.documentListArray = this.fetchDocumentsData(this.uuid);
                        }
                        break;
                    }
                    default: {
                        console.error('Invalid documents group type');
                        break;
                    }
                }
                this.countTotalItemsPending();
                this.loading = false;
                this.filterData(filterData);
                this.$emit('emitDocument', this.documentListArray);
            } catch (err) {
                this.$bvToast.toast(`${err.message}`, {
                    title: `Error ${err.name}`,
                    autoHideDelay: 10000,
                    variant: 'danger'
                });
            } finally {
                this.loading = false;
            }
        },

        fetchDocumentsData(uuid) {
            const documents = this.$store.getters.getDocuments;
            if (documents[uuid]) {
                return documents[uuid];
            } else {
                return { name: '', items: [] };
            }
        },

        filterData(filterBy) {
            let filteredDataArray = _.cloneDeep(this.documentListArray);

            if (!filterBy || (!filterBy.type && !filterBy.search && !filterBy.showPendings)) {
                this.filteredData = filteredDataArray;
            } else if (filterBy.showPendings) {
                this.filteredData.items = filteredDataArray.items.filter(x => {
                    if (x.is_signable === true && !x.is_signed && !x.is_validated) {
                        return true;
                    } else if (
                        x.key_subcategory === 'DOCUMENTO_ACREDITATIVO_TITULARIDAD_CC' &&
                        !x.document_uri
                    ) {
                        return true;
                    }
                    return false;
                });
            } else if (filterBy.type && filterBy.search) {
                this.filteredData.items = filteredDataArray.items.filter(item => {
                    if (
                        item.key_subcategory === filterBy.type &&
                        item.title.toUpperCase().includes(filterBy.search.toUpperCase())
                    )
                        return item;
                });
            } else if (filterBy.type && !filterBy.search) {
                this.filteredData.items = filteredDataArray.items.filter(item => {
                    if (item.key_subcategory === filterBy.type) return item;
                });
            } else if (!filterBy.type && filterBy.search) {
                this.filteredData.items = filteredDataArray.items.filter(item => {
                    if (item.title) {
                        if (item.title.toUpperCase().includes(filterBy.search.toUpperCase()))
                            return item;
                    }
                });
            }
        },
        /**
         * Cuenta el total de items pendientes (requeridos y no validados)
         * Emite el resultado que es recibido por el componente padre del bastanteo
         * Este método se lanza cuano se hace el fetchData
         */
        countTotalItemsPending() {
            /*const docsPendingRequiredValidated = this.documentListArray.items.filter(
                x => x.is_required === true && (!x.is_validated || x.is_validated === null)
            );*/
            const docsPendingRequiredUploaded = this.documentListArray.items.filter(x => {
                if (x.is_signable === true && !x.is_signed && !x.is_validated) {
                    return true;
                }
                return false;
            });

            this.docsPending = docsPendingRequiredUploaded.length;
            this.$root.$emit('emit_items_not_validated', docsPendingRequiredUploaded.length);
        },

        handleAddDocument() {
            if (this.isMobile()) {
                this.addOtherDocument = !this.addOtherDocument;
            } else {
                this.$root.$emit(
                    'emit_show_upload',
                    { key_category: 'DOCUMENTATION', key_subcategory: 'OTHERS' },
                    this.type,
                    this.uuid,
                    true,
                    null
                );
            }
        },

        isMobile() {
            return window.innerWidth <= 991;
        }
    }
};
